import { Building2, Sparkles, User, Globe, AlertCircle } from 'lucide-react';

const AudienceCard = ({ icon: Icon, title, description }) => (
  <div className="service-card bg-white border border-gray-200 rounded-xl p-8 text-center group">
    <div className="w-16 h-16 bg-primary/10 rounded-xl flex items-center justify-center mx-auto group-hover:bg-primary/20 transition-colors">
      <Icon className="w-8 h-8 text-primary" />
    </div>
    <h3 className="font-oswald uppercase text-xl font-bold text-gray-900 mt-6">
      {title}
    </h3>
    <p className="font-manrope text-sm text-gray-500 mt-2">
      {description}
    </p>
  </div>
);

export const WhoThisIsFor = () => {
  return (
    <section
      data-testid="who-this-is-for-section"
      className="relative py-24 md:py-32 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <span className="font-manrope uppercase tracking-widest text-xs font-semibold text-primary">
            Our Clients
          </span>
          <h2
            className="font-oswald uppercase tracking-tight font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-tight mt-4"
            data-testid="who-this-is-for-headline"
          >
            <span className="text-gray-900">Who we work</span>
            <br />
            <span className="text-primary">best with</span>
          </h2>
        </div>

        {/* Audience Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div data-testid="audience-card-1">
            <AudienceCard 
              icon={Building2}
              title="Brands"
              description="Serious about social media as a growth engine"
            />
          </div>
          <div data-testid="audience-card-2">
            <AudienceCard 
              icon={Sparkles}
              title="Creators"
              description="Building long-term businesses"
            />
          </div>
          <div data-testid="audience-card-3">
            <AudienceCard 
              icon={User}
              title="Founders & Executives"
              description="Building authority and visibility"
            />
          </div>
          <div data-testid="audience-card-4">
            <AudienceCard 
              icon={Globe}
              title="Companies"
              description="Entering or scaling in MENA"
            />
          </div>
        </div>

        {/* Filter Line */}
        <div
          className="mt-16 bg-white border border-primary/30 rounded-xl p-6 md:p-8 shadow-sm"
          data-testid="filter-notice"
        >
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <AlertCircle className="w-5 h-5 text-primary" />
            </div>
            <div>
              <h3 className="font-oswald uppercase text-lg font-bold text-gray-900">
                Important Note
              </h3>
              <p className="font-manrope text-base text-gray-500 mt-2">
                If you're looking for viral hits or cheap CPMs, we're not the right partner.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
